/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Syntx_Meta_DescriptionInputs */

const en_syntx_meta_description = /** @type {(inputs: Syntx_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore Sintex AI video creation with text prompts, reference images and video examples. Learn about the Syntx AI workflow and plan your next clip.`)
};

const zh_syntx_meta_description = /** @type {(inputs: Syntx_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索 Sintex AI 视频创作，配置提示词、参考图片和画幅，观看视频示例，了解 Syntx AI 的视频工作流。`)
};

/**
* | output |
* | --- |
* | "Explore Sintex AI video creation with text prompts, reference images and video examples. Learn about the Syntx AI workflow and plan your next clip." |
*
* @param {Syntx_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const syntx_meta_description = /** @type {((inputs?: Syntx_Meta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Syntx_Meta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_syntx_meta_description(inputs)
	return zh_syntx_meta_description(inputs)
});
export { syntx_meta_description as "syntx.meta.description" }